import { useState, forwardRef, useImperativeHandle } from "react"
import { Modal } from "../modals/Modal"
import { func } from "prop-types"
import { contributorPropType } from "./contributorPropType"
import { contributorPermissionLookup } from "./contributorPermissionLookup"
import AccountCenterSearch from "components/admin/account_center_search/account_center_search"

export const ContributorsModal = forwardRef(function ContributorsModal({ onSave, onCancel }, ref) {
  const [person, setPerson] = useState(null)
  const [isContributorExisting, setIsContributorExisting] = useState(false)

  const initializePerson = person => {
    console.log(person)
    setPerson(person)
    setIsContributorExisting(true)
  }

  useImperativeHandle(
    ref,
    () => ({
      initializePerson
    }),
    []
  )

  const clearSelectedPerson = () => {
    setPerson(null)
    setIsContributorExisting(false)
  }

  const handleCancel = () => {
    onCancel()
    clearSelectedPerson()
  }

  const handleSave = () => {
    onSave(person)
    clearSelectedPerson()
  }

  return (
    <Modal
      title={`${isContributorExisting ? "Edit" : "Add"} contributor`}
      onModalSubmit={handleSave}
      onModalCancel={handleCancel}
    >
      <div>
        {person ? (
          <div>
            <ContributorEdit person={person} />
          </div>
        ) : (
          <ContributorSearch setPerson={setPerson} />
        )}
      </div>
    </Modal>
  )
})

ContributorsModal.propTypes = {
  onSave: func.isRequired,
  onCancel: func.isRequired
}

const ContributorSearch = ({ setPerson }) => {
  const formatPersonFromSearch = person => {
    const attributes = {
      avatar_url: person.avatar_url,
      name: person.name,
      first_name: person.first_name,
      last_name: person.last_name,
      primary_email_address: person.primary_email_address
    }

    setPerson({
      id: person.account_center_id,
      ...attributes,
      attributes: attributes,
      permission_level: "no_access"
    })
  }
  return (
    <AccountCenterSearch
      onSelect={formatPersonFromSearch}
      inputProps={{
        placeholder: "Search for someone to add",
        autoFocus: false
      }}
    />
  )
}
ContributorSearch.propTypes = {
  setPerson: func.isRequired
}

const ContributorEdit = ({ person }) => {
  return (
    <div>
      <div
        className="d-f ai-c g-1"
        css={{
          borderRadius: "var(--t-border-radius-default)",
          border: "1px solid var(--t-border-color-default-base)",
          padding: "calc(var(--t-spacing-1) + var(--t-spacing-half))"
        }}
      >
        <img
          src={person.avatar_url}
          alt={`${person.name} avatar`}
          css={{ width: "48px", height: "48px", borderRadius: "100%" }}
        />
        <div className="d-f fd-c">
          <div css={{ color: "var(--link--color)" }}>{person.name}</div>
          {person.primary_email_address && (
            <div
              css={{
                fontSize: "var(--t-font-size-sm)",
                color: "var(--t-text-color-default-secondary)"
              }}
            >
              {person.primary_email_address}
            </div>
          )}
        </div>
      </div>
      <div className="mt-3">
        <p css={{ fontSize: "var(--t-font-size-sm)" }}>
          {person.first_name} currently has{" "}
          {contributorPermissionLookup[person.permission_level].toLowerCase()} to signups in this
          account. Use the selection below to change their permissions for this signup.
        </p>
      </div>
      <div>
        <select className="select" css={{ borderColor: "var(--t-border-color-default-base)" }}>
          {Object.entries(contributorPermissionLookup).map(([value, label]) => (
            <option key={value} value={value} selected={value === person.permission_level}>
              {label}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}

ContributorEdit.propTypes = {
  person: contributorPropType.isRequired
}
